import React from "react";
import { TemplateWrapped } from "../Layout";
import "./index.css";
import FieldsTable from "./components/fields-table/FieldsTable";
import { HeaderFilterButton } from "../RemarkTemplate/Body";
import FormFilterJsonViewer from "./components/form-filter-json-viewer/FormFilterJsonViewer";
import { faSearch } from "@fortawesome/fontawesome-free-solid";
import { useJsonViewerContainer } from "./hooks/useJsonViewerContainer";
import { FaBoxOpen } from "react-icons/all";
import withSelectedPractices from "../HOCS/withSelectedPractices/withSelectedPractices";

/**
 * Extrae del payload solo los campos relevantes para pintar en la página.
 *
 * @param {Object} data - JSON completo recibido
 * @returns {Object} JSON con solo los campos amarillos relevantes
 */
function extractYellowFields(data) {
  if (!data || typeof data !== "object") return;

  const { provider, subscriber, dependents = [], payer, planStatus } = data;

  return {
    provider: provider ? { providerName: provider?.providerName || "" } : {},

    subscriber: subscriber
      ? {
          firstName: subscriber?.firstName || "",
          lastName: subscriber?.lastName || "",
          middleName: subscriber?.middleName || "",
        }
      : {},

    dependents:
      dependents && dependents.length > 0
        ? dependents.map((dep) => ({
            firstName: dep?.firstName || "",
            lastName: dep?.lastName || "",
            middleName: dep?.middleName || "",
            gender: dep?.gender || "",
            dateOfBirth: dep?.dateOfBirth || "",
            planNumber: dep?.planNumber || "",
            relationToSubscriber: dep?.relationToSubscriber || "",
            insuredIndicator: dep?.insuredIndicator || "",
          }))
        : [],

    payer: payer
      ? {
          name: payer?.name || "",
        }
      : undefined,

    planStatus:
      planStatus && planStatus?.length > 0 && planStatus[0]
        ? {
            status: planStatus[0]?.status || "",
            planDetails: planStatus[0]?.planDetails || "",
          }
        : {},
  };
}

const JsonViewerContainer = () => {
  const {
    jsonData,
    formData,
    handleChange,
    handleSubmit,
    resetForm,
    isFormComplete,
    handleChangeDateOfBirth,
    isLoading,
    errors,
    handleCloseErrors,
    tradingPartnerSelected,
    setTradingPartnerSelected,
    payers,
  } = useJsonViewerContainer();

  const extractedData = extractYellowFields(jsonData);
  return (
    <TemplateWrapped title="Insurance Verification | Real Time">
      <div className=" bg-white p-8 max-w-4xl">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            padding: "1rem",
          }}
        >
          <HeaderFilterButton
            active={true}
            render={FormFilterJsonViewer}
            componentProps={{
              formData,
              handleChange,
              handleSubmit,
              resetForm,
              isFormComplete,
              handleChangeDateOfBirth,
              isLoading,
              errors,
              handleCloseErrors,
              tradingPartnerSelected,
              setTradingPartnerSelected,
              payers,
            }}
            icon={faSearch}
            message="Please fill al fields"
            placement="auto-end"
          />
        </div>
        {jsonData && <FieldsTable jsonData={extractedData} />}
        {!jsonData && (
          <div style={{ paddingBottom: "1rem" }}>
            <div className="empty-data mb-4">
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <FaBoxOpen style={{ color: "rgb(156 163 175)" }} size={40} />
              </div>
              <p className="empty-data-label m-0">
                No information available to show
              </p>
            </div>
          </div>
        )}
      </div>
    </TemplateWrapped>
  );
};
export default withSelectedPractices(JsonViewerContainer);
